// TimestampContext.tsx
import React, { createContext, useContext, useState } from 'react';

type TimestampContextType = {
  timestamp: string | number;
  setTimestamp: (value: string | number) => void
};

const TimestampContext = createContext<TimestampContextType | undefined>(undefined);

export const TimestampProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [timestamp, setTimestamp] = useState<string | number>("");

  return (
    <TimestampContext.Provider value={{ timestamp, setTimestamp }}>
      {children}
    </TimestampContext.Provider>
  );
};

export const useTimestamp = () => {
  const context = useContext(TimestampContext);
  if (!context) {
    throw new Error('useTimestamp must be used within a TimestampProvider');
  }
  return context;
};